<!-- Seta usada nos 4 selects/combobox de AccountFormFields.vue — o `class`
     passado por quem usa (ex. $style.chevron/$style.chevronStandalone) cai
     direto no <svg> raiz via fallthrough attrs do Vue, então a cor (stroke)
     vem de lá. -->
<template>
  <svg
    aria-hidden="true"
    fill="none"
    height="14"
    viewBox="0 0 16 16"
    width="14"
  >
    <path
      d="M3 6l5 5 5-5"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2.2"
    />
  </svg>
</template>
